module.exports = __webpack_public_path__ + "img/15.f61e1efd.jpg";